export const SESSION_STORAGE_KEY = {
  SESSION_KEY: "session_key",
  USERNAME: "username",
  USER_ID: "user_id",
  USER_EMAIL: "user_email",
  SELECTED_SHARD: "selected_shard",
};

export const HTTP_RESPONSE_CODE = {
  UNAUTHORIZED: 401,
};

export const NOTIFICATION_TYPE = {
  NONE: 0,
  INCOME_OUTGO: 1,
  INCOME: 2,
  OUTGO: 3,
};

export const THEME_TYPE = {
  DARK: "dark",
  LIGHT: "light",
};

export const LOCAL_STORAGE_KEY = {
  THEME: "theme",
  EXTENSION_ID: "extensionID",
};
